import { render, staticRenderFns } from "./Licoes.vue?vue&type=template&id=434a84c6&"
import script from "./Licoes.vue?vue&type=script&lang=js&"
export * from "./Licoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports